// API klienta portalu — osobny token (sp_klient_token) i namespace /api/k/<slug>/...
const API_BASE = process.env.REACT_APP_API_URL || '';

const TOKEN_KEY = 'sp_klient_token';

export const klientAuth = {
  get token() { return localStorage.getItem(TOKEN_KEY); },
  set token(v) {
    if (v) localStorage.setItem(TOKEN_KEY, v);
    else localStorage.removeItem(TOKEN_KEY);
  },
  logout() { localStorage.removeItem(TOKEN_KEY); },
};

function authedReq(method, path, body) {
  const token = localStorage.getItem(TOKEN_KEY);
  return fetch(`${API_BASE}/api/k${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async r => {
    if (r.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      throw new Error('Sesja wygasła. Zaloguj się ponownie.');
    }
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.error || 'Błąd serwera');
    return data;
  });
}

function publicReq(method, path, body) {
  return fetch(`${API_BASE}/api/k${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async r => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.error || 'Błąd serwera');
    return data;
  });
}

export const klientApi = {
  branding: (slug) => publicReq('GET', `/${encodeURIComponent(slug)}/branding`),
  login: (slug, email) => publicReq('POST', `/${encodeURIComponent(slug)}/login`, { email }),
  verify: (slug, email, code) => publicReq('POST', `/${encodeURIComponent(slug)}/verify`, { email, code }),
  me: () => authedReq('GET', '/me'),
  spacery: () => authedReq('GET', '/spacery'),
  faktury: () => authedReq('GET', '/faktury'),
  setLang: (lang) => authedReq('POST', '/lang', { lang }),
  zglosUsuniecie: (id, zglos = true, preview = false) => authedReq('POST', `/spacery/${id}/zglos-usuniecie`, { zglos, preview }),
  downloadFakturaPdf: (id, filename) => {
    const token = localStorage.getItem(TOKEN_KEY);
    return fetch(`${API_BASE}/api/k/faktury/${id}/pdf`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(async r => {
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Błąd pobierania'); }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename || `faktura-${id}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    });
  },
  // Pakiety mają osobny endpoint pdf (inna tabela). `id` to liczbowy id pakietu,
  // BEZ prefiksu "pakiet-" (ten prefix jest tylko w polu `id` w odpowiedzi
  // /api/k/faktury — żeby React mógł odróżnić wiersze hostingu od pakietów).
  downloadPakietPdf: (id, filename) => {
    const token = localStorage.getItem(TOKEN_KEY);
    return fetch(`${API_BASE}/api/k/pakiety/${id}/pdf`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(async r => {
      if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || 'Błąd pobierania'); }
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename || `pakiet-${id}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    });
  },
  simulate: (doDate, spacerId) => {
    const qs = new URLSearchParams({ do: doDate });
    if (spacerId) qs.set('spacer_id', String(spacerId));
    return authedReq('GET', `/simulate?${qs}`);
  },
  downloadRaport: async ({ symulacja_data, spacer_id, lang } = {}) => {
    const token = localStorage.getItem(TOKEN_KEY);
    const qs = new URLSearchParams();
    if (symulacja_data) qs.set('symulacja_data', symulacja_data);
    if (spacer_id) qs.set('spacer_id', String(spacer_id));
    if (lang) qs.set('lang', lang);
    const r = await fetch(`${API_BASE}/api/k/raport.pdf${qs.toString() ? '?' + qs : ''}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) {
      const d = await r.json().catch(() => ({}));
      throw new Error(d.error || 'Nie udało się pobrać raportu');
    }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    // nazwa z Content-Disposition
    const cd = r.headers.get('content-disposition') || '';
    const m = cd.match(/filename="?([^";]+)"?/i);
    const filename = m ? m[1] : 'raport.pdf';
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  },
};
